module.exports = __webpack_public_path__ + "img/Spain.2f1696bc.svg";